var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.forId ? 'label' : 'span',_vm._b({tag:"component",class:_vm.fontCss},'component',_vm.forId ? { for: _vm.forId } : {},false),[_vm._v("\n  "+_vm._s(_vm.fontText)+"\n  "),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }